import { RootState } from '../store';

export const getResetStoreCounter = (state: RootState) => state.common.resetStoreCounter;
export const getActiveTab = (state: RootState) => state.common.activeTab;
export const getActiveSessionId = (state: RootState) => state.common.activeSessionId;
export const getIsEditorOpen = (state: RootState) => state.common.isEditorOpen;
export const getIsSidebarOpen = (state: RootState) => state.common.isSidebarOpen;
export const getIsEditorOpenInFullMode = (state: RootState) => state.common.isEditorInFullMode;

export const getChangeBrandLoading = (state: RootState) => state.common.loading.changeBrandLoading;
export const getFetchInitialAssetsLoading = (state: RootState) =>
    state.common.loading.fetchInitialAssetsLoading;
export const getFetchBrandElementsLoading = (state: RootState) =>
    state.common.loading.fetchBrandElementsLoading;
export const getCampaignsLoading = (state: RootState) => state.common.loading.campaignsLoading;
export const getSessionsLoading = (state: RootState) => state.common.loading.sessionsLoading;
